export default __webpack_public_path__ + "static/WebUI-MenuVideoBar_RecPath-502d1701cd353e9cd4a7d5aac2783014.png";